import React from 'react';
import styles from './Platforms.module.scss';

import _ from 'lodash';
import sopranoImg from "../../../assets/soprano.png";
import {$getLanguage, $t} from "../../../helpers/translator";
import api from "../../../helpers/api";
import PlatformsGrid from "../../../components/PlatformsGrid/PlatformsGrid";
import EquipmentSpecifications from "../../../components/clinic/EquipmentSpecifications/EquipmentSpecifications";
import ProductFamily from "../../../components/clinic/ProductFamily/ProductFamily";
import PlatformUsagePieChart from "components/PlatformUsagePieChart/PlatformUsagePieChart";
import Loader from '../../../components/miscellaneous/Loader/Loader';


class ChainPlatformsPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            lang: $getLanguage(),
            statistics: null,
        };
    }

    async componentDidMount() {
        await this.getPlatformsStatistics()
    }

    async getPlatformsStatistics() {
        //    platforms/stats
        try {

            let res = await api.get('/platform/statistic');
            // console.log('/platform/statistics', res)

            if (res && res.data && res.data.success) {
                let statistics = {...res.data.data}
                statistics.count = 0;
                _.forEach(statistics.platformsCount, (v, k) => {
                    statistics.count += v.count;
                })

                // this.renderPieChart(statistics.usage)

                this.setState({statistics: statistics}, () => {
                    // console.log('this.state', this.state)
                })
            }
        } catch (e) {
            console.error('err get clinics (platforms pg):', e);
        }
    }

    getStatHours = (stat) => {
        let times = this.state.statistics?.usage?.time;
        if(times) {
            if(times[stat]) {
                const hours = times[stat] / 60 / 60;
                if(hours > 1) {
                    if(hours < 10000) {
                        const hoursTranslation = $t('global.dateTime.hours');
                        return hours.toFixed(2) + ' ' + hoursTranslation;
                    } else {
                        const days = hours / 24;
                        const daysTranslation = $t('global.dateTime.days');
                        return days.toFixed(2) + ' ' + daysTranslation;
                    }
                } else {
                    const minutes = times[stat] / 60;
                    if(minutes > 0) {
                        const minutesTranslation = $t('global.dateTime.minutes');
                        return minutes.toFixed(2) + ' ' + minutesTranslation;
                    } else {
                        return $t('global.machines.pieChart.noActivity')
                    }
                }
            }
        }
    }

    getTranslation = (key) => {
        const t = $t(`global.machines.pieChart.${key}`);
        return t.split('/')[0].split(' + ')[0];
    }


    render() {
        let statistics = this.state.statistics;
        let times = this.state.statistics?.usage?.time;

        return (<div className={'container'}>
            <div className={'box'}>
                <div className={'alma-box'}>
                    <div className={'alma-box-header'}>
                        <div><h3>{$t('global.machines.chainPlatformsStatistics')}</h3></div>
                    </div>
                    <div className={`${'alma-box-content'} ${styles.statisticsContainer}`}>
                        <div className={styles.flex}>
                            <div className={styles.platformsCountContainer}>
                                <div className={styles.platformsCount}>
                                    {statistics ? statistics.count : '...'}
                                </div>
                                <div>{$t('global.machines.platforms')}</div>
                            </div>
                            <div className={styles.platformImage}>
                                <img src={sopranoImg} alt={'Soprano'}/>
                            </div>
                        </div>
                        <div className={`d-flex align-items-center ${styles.flexWrap}`}>
                            {/* <div className={styles.pieChart} id={'main-platforms-usage-pie-chart'}/> */}
                            <div>
                                {statistics ? <div className={styles.usageData}>
                                    
                                    <div>
                                        <span>{this.getTranslation('online')}</span>
                                        <h3 style={{color: '#473073'}}>{this.getStatHours('online')}</h3>
                                    </div>
                                    <div>
                                        <span>{this.getTranslation('treatment')}</span>
                                        <h3 style={{color: '#319aa1'}}>{this.getStatHours('treatment')}</h3>
                                    </div>
                                    <div>
                                        <span>{this.getTranslation('lasing')}</span>
                                        <h3 style={{color: '#f7c59f'}}>{this.getStatHours('lasing')}</h3>
                                    </div>

                                </div> : <Loader />}
                                
                            </div>
                            <div>
                                {statistics && <PlatformUsagePieChart size={200} data={{
                                    lasing: this.state.statistics.usage.percentage.lasing,
                                    treatment: this.state.statistics.usage.percentage.treatment,
                                    online: this.state.statistics.usage.percentage.online,
                                }} />}
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <PlatformsGrid {...this.props} userType={3} getUsage={true} />

            <div className={styles['promotional-row']}>
                <div className={styles.box}>
                    <EquipmentSpecifications/>
                </div>
                <div className={styles.box}>
                    <ProductFamily/>
                </div>
            </div>
        </div>);
    }
}


export default ChainPlatformsPage;
